import axios from "axios";

const SERVICE_API_URL = process.env.REACT_APP_SERVICE_URL
export const ADD_NEW_PAYMENT = `${SERVICE_API_URL}/api/v1/Payment/AddNewPayment`
export const CHARGE_WALLET = `${SERVICE_API_URL}/api/v1/Payment/ChargeWallet`
export const GET_CENTER_WALLET = `${SERVICE_API_URL}/api/v1/Payment/GetProducerCenterWallet`
export const GET_PAYMENT_HISTORY_BY_PRODUCER_CENTER = `${SERVICE_API_URL}/api/v1/Payment/GetPaymentHistoryByProducerCenter`
export const GET_FACTOR_BY_ID = `${SERVICE_API_URL}/api/v1/Payment/GetFactorById`
export const UPDATE_PAYMENT = `${SERVICE_API_URL}/api/v1/Payment/UpdatePayment`
export const ADD_PACKAGE_TO_USER = `${SERVICE_API_URL}/api/v1/Payment/AddPackageToUser`

export function AddNewPayment(price, centerId: string) {
    var bodyFormData = new FormData();
    bodyFormData.append('Price', price);
    bodyFormData.append('CenterId', centerId);
    return axios.post(ADD_NEW_PAYMENT, bodyFormData)
        .catch(error => {
            return error;
        });
}

export function chargeWalletRequest(authority: string) {
    var bodyFormData = new FormData();
    bodyFormData.append('Authority', authority);
    return axios.post(CHARGE_WALLET, bodyFormData)
        .catch(error => {
            return error;
        });
}

export function GetProducerCenterWalletPrice(producerCenterId: string) {
    return axios.get(`${GET_CENTER_WALLET}?ProducerCenterId=${producerCenterId}`)
        .catch(error => {
            return error;
        })
}


export function GetProducerCenterPaymentHistories(
    producerCenterId: string,
    page: number,
    pageSize: number,
) {
    var url = `${GET_PAYMENT_HISTORY_BY_PRODUCER_CENTER}?ProducerCenterId=${producerCenterId}&Page=${page}&PageSize=${pageSize}`
    return axios.get(url)
        .catch(error => {
            return error;
        })
}

export function GetFactorById(factorId : string){
    return axios.get(`${GET_FACTOR_BY_ID}/${factorId}`)
    .catch(error => {
        return error;
    })
}

export function UpdatePayment(paymentId : string){
    var bodyFormData = new FormData();
    bodyFormData.append('PaymentId', paymentId);
    return axios.post(UPDATE_PAYMENT, bodyFormData)
        .catch(error => {
            return error;
        });
}

export function AddPackageToUserRequest(authority: string) {
    var bodyFormData = new FormData();
    bodyFormData.append('Authority', authority);
    return axios.post(ADD_PACKAGE_TO_USER, bodyFormData)
        .catch(error => {
            return error;
        });
}